import { ReactComponent as GoldIcon } from "assets/filter/gold.svg";
import { ReactComponent as SilverIcon } from "assets/filter/silver.svg";
import { ReactComponent as BronzeIcon } from "assets/filter/bronze.svg";
import { ReactComponent as GoldCup } from "assets/cup_icon/gold-cup.svg";
import { ReactComponent as SilverCup } from "assets/cup_icon/silver-cup.svg";
import { ReactComponent as BronzeCup } from "assets/cup_icon/brown-cup.svg";

import { ReactComponent as GoldBar } from "assets/icons/YellowGoldBar.svg";
import { ReactComponent as WhiteBar } from "assets/icons/WhiteGoldBar.svg";
import { ReactComponent as RoseGoldBar } from "assets/icons/RoseGoldBar.svg";

import { ReactComponent as HQ } from "assets/icons/HQ_Pointer.svg";
import { ReactComponent as BBM } from "assets/icons/BBM_Pointer.svg";
import { ReactComponent as BBMCustomer } from "assets/icons/BBM_Cust_Pointer.svg";
import { ReactComponent as BBS } from "assets/icons/BBS_Pointer.svg";
import { ReactComponent as BBSCustomer } from "assets/icons/BBS_Cust_Pointer.svg";
import { ReactComponent as IDL } from "assets/icons/IDL_Cust_Pointer.svg";
import { ReactComponent as UnderRatio } from "assets/icons/underRatio.svg";

const renderIcon = (item, category) => {
  switch (item) {
    case "Gold":
      return category === "Class" ? <GoldIcon /> : <GoldCup />;
    case "Silver":
      return category === "Class" ? <SilverIcon /> : <SilverCup />;
    case "Bronze":
      return category === "Class" ? <BronzeIcon /> : <BronzeCup />;
    case "Under Ratio":
      return category === "Class" ? <UnderRatio /> : <UnderRatio />;
    case "Yellow Gold":
      return category === "Gold Color" ? <GoldBar /> : <GoldBar />;
    case "Rose Gold":
      return category === "Gold Color" ? <RoseGoldBar /> : <RoseGoldBar />;
    case "White Gold":
      return category === "Gold Color" ? <WhiteBar /> : <WhiteBar />;
    case "Headquarters Stock":
      return category === "Location" ? <HQ /> : <HQ />;
    case "BBM Stock":
      return category === "Location" ? <BBM /> : <BBM />;
    case "BBM Customer Stock":
      return category === "Location" ? <BBMCustomer /> : <BBMCustomer />;
    case "BBS Stock":
      return category === "Location" ? <BBS /> : <BBS />;
    case "BBS Customer Stock":
      return category === "Location" ? <BBSCustomer /> : <BBSCustomer />;
    case "IDL":
      return category === "Location" ? <IDL /> : <IDL />;
    default:
      return null;
  }
};

export default renderIcon;
